module.exports = __webpack_public_path__ + "img/rank16.2f3feafd.png";